export default "__VITE_ASSET__hAdDmD5x__"